class CollectionDescriptionToggle extends HTMLElement {
  constructor() {
    super();
    this.description = this.querySelector('[data-description]');
    this.button = this.querySelector('[data-toggle]');
    this.toggleText = this.querySelector('[data-toggle-text]');
    this.button.addEventListener('click', this.toggle.bind(this));
  }

  connectedCallback() {
    // Only reveal the toggle if the description actually overflows its collapsed height.
    requestAnimationFrame(() => {
      if (this.description.scrollHeight > this.description.clientHeight + 2) {
        this.button.hidden = false;
      }
    });
  }

  toggle() {
    const expanded = this.description.classList.toggle('is-expanded');
    this.button.setAttribute('aria-expanded', expanded);
    this.toggleText.textContent = expanded ? this.dataset.lessLabel : this.dataset.moreLabel;
  }
}

customElements.define('collection-description-toggle', CollectionDescriptionToggle);
